import styled from 'styled-components';
import { colors } from '@dexma/ui-components';

export const StyledSidePanel = styled.div`
    border-left: 1px solid ${colors.gray300};
    height: 100%;
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    width: 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${colors.white};
`;

export const StyledDivider = styled.hr`
    height: 1px;
    background-color: ${colors.gray300};
    border: none;
    margin: 0;
    width: 100%;
    flex: none;
`;

export const StyledTitleBarGrid = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
    height: 64px;
    padding: 0px 15px 0px 30px;
    flex: none;

    svg {
        cursor: pointer;
    }

    .heading {
        display: flex;
        flex: 1 1 auto;
        align-items: center;
        .button-back {
            margin-right: 7px;
        }
        h3 {
            margin: 0;
        }
    }

    .close-icon {
        flex: 0 1 auto;
    }
`;

export const StyledFixedHeader = styled.div`
    margin-top: 8px;
    width: 95%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
`;
export const StyledScrollableContent = styled.div`
    width: 100%;
    flex: 1 1 auto;
    overflow: hidden;
    display: flex;
    justify-content: center;
`;
